import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardNavigation from '../DashboardNavigation';
import DashboardBottomNav from './DashboardBottomNav';
import Header from '../ui/Header';

/**
 * Layout-Komponente für alle Dashboard-Ansichten
 * Stellt eine einheitliche Struktur mit Navigation und Header bereit
 */
const DashboardLayout = ({ children }) => {
  // Seitengrund `bg-background` statt `bg-surface-raised` — derselbe Grund, auf
  // dem `ui/PageShell` und damit der ganze Rest der App steht. Die
  // `ui/`-Bausteine sind dagegen entworfen: `Card` hebt sich per Rand und
  // `shadow-token-sm` ab, `StatTile` (`bg-surface-raised`) als getoente Kachel.
  // Auf dem bisherigen grauen Grund waere eine StatTile-Reihe unsichtbar
  // geworden, sobald die weisse Seitenkarte darum wegfaellt.
  return (
    <div className="min-h-screen bg-background">
      {/* Header - schlanke Leiste (Profilbild + "Zur App"); die Navigation
          liefert die Seitenleiste bzw. die Glasleiste unten */}
      <Header />

      {/* Bodenabstand: Auf dem Telefon schwebt unten die Glasleiste, also gilt
          `--page-bottom-nav` (= `--bottom-nav-clearance`, Safe Area inklusive) —
          dasselbe Mass, mit dem `ui/PageShell` rechnet. Die Grenze ist `md:`
          und nicht `sm:`, weil Seitenleiste und Glasleiste genau dort tauschen;
          bei `sm:` laege die Leiste zwischen 640 und 767px auf dem Inhalt.
          Seitenrand 16px (`px-4`) wie im Rest der App (Okt 2026); den Wert von
          `--page-bottom-nav` erhöht index.css um 1rem Luft über der Leiste. */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-3 sm:pt-6 pb-[var(--page-bottom-nav)] md:pb-6">
        <div className="flex flex-col md:flex-row md:gap-6">
          {/* Seitennavigation (nur ab Tablet; darunter die Glasleiste) */}
          <aside className="hidden md:block md:w-64 flex-shrink-0">
            <DashboardNavigation />
          </aside>

          {/* Hauptinhalt.
              Die weisse Seitenkarte gibt es erst ab Tablet (`md:`). Auf dem
              Telefon war sie eine Karte um lauter Karten: 12px Seitenrand vom
              Container plus 12px Kartenpolster plus nochmal 12–24px von der
              Karte darin — auf 390px Breite gingen so bis zu 18 % des Schirms
              fuer Rahmen drauf. Und weil Karte und Untergrund beide `bg-surface`
              (im Hellen: weiss) sind, trennte sie am Ende nur eine 1px-Linie.
              Der Rest der App macht es andersherum: Seite traegt den ruhigen
              Grund, die Karten tragen die Flaeche (`ui/PageShell`). */}
          <main className="flex-1 min-w-0 md:bg-surface md:rounded-xl md:shadow-token-sm md:p-6">
            {children || <Outlet />}
          </main>
        </div>
      </div>

      <DashboardBottomNav />
    </div>
  );
};

export default DashboardLayout;
